<template>

    <div class="index background">

        <div class="userinfo">

            <div class="userinfo-title">完善资料</div>

            <div class="userinfo-avatar cf">

                <div class="userinfo-floor-label avatar-label fl">头像</div>

                <div class="userinfo-avatar-value cf fl">

                    <img class="avatar fl" :src="data.head_pic || require('../../assets/images/avatar.png')"/>

                    <el-upload
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :http-request="uploadHttp"
                    >

                        <div class="userinfo-edit fl cf relative">

                            <img class="fl" src="./images/me_icon_edit@2x.png" />

                            <div class="fl">修改</div>

                        </div>

                    </el-upload>

                </div>

            </div>

            <div class="userinfo-floor cf">

                <div class="userinfo-floor-label floor-label fl">昵称</div>

                <div class="userinfo-floor-value fl">

                    <el-input class="width" v-model="data.nickname" placeholder="请输入"/>

                </div>

            </div>

            <div class="userinfo-floor cf">

                <div class="userinfo-floor-label floor-label fl">性别</div>

                <div class="userinfo-floor-value fl">

                    <el-select
                        class="width"
                        clearable
                        v-model="data.sex"
                    >

                        <el-option
                            v-for="item in genderList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>

                    </el-select>

                </div>

            </div>

            <div class="userinfo-floor cf">

                <div class="userinfo-floor-label floor-label fl">生日</div>

                <div class="userinfo-floor-value fl">

                    <el-date-picker
                        class="width"
                        v-model="data.birthday"
                        type="date"
                        placeholder="选择生日"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>

                </div>

            </div>

            <div class="userinfo-floor cf">

                <div class="userinfo-floor-label floor-label fl">所在地</div>

                <div class="userinfo-floor-value fl">

                    <el-cascader
                        class="user-address"
                        v-model="address_value"
                        :options="address_list"
                        separator=","
                        :props="optionProps"
                        clearable
                        @change="handleChange"
                    ></el-cascader>

                </div>

            </div>

            <div class="userinfo-floor cf">

                <div class="userinfo-floor-label floor-label fl">联系方式</div>

                <div class="userinfo-floor-value fl">

                    <el-input class="width" v-model="data.phone" placeholder="请输入"/>

                </div>

            </div>

            <div class="userinfo-textarea cf">

                <div class="userinfo-floor-label floor-label fl">个性签名</div>

                <div class="userinfo-text fl">

                    <el-input
                        type="textarea"
                        placeholder="介绍一下自己吧，别人会更了解你哦~"
                        v-model="data.signature">
                    </el-input>

                </div>

            </div>

            <div class="button button-active save-btn" @click="submitSave">保存</div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "userinfo",
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
